import repository from "./PositionRepository";

import {
  Column,
  FilterRow,
  RequiredRule,
  StringLengthRule,
} from "devextreme-react/data-grid";
import DataGridView from "Component/DataGridView";
import TreeLookupEdit from "Component/TreeLookupEdit";
import { useState } from "react";
const PositionPage = (props) => {
  const [positions, setPositions] = useState([]);
  return (
    <DataGridView
      access={props.info.access}
      load={repository.all}
      insert={repository.insert}
      remove={repository.delete}
      update={repository.update}
      onLoadComplete={(data) => setPositions(data)}
    >
      <FilterRow visible={true} />
      <Column dataField="id" caption="Kode Jabatan">
        <RequiredRule />
        <StringLengthRule max={50} message="Maksimal panjang kata 50" />
      </Column>
      <Column dataField="name" caption="Nama Jabatan">
        <RequiredRule />
      </Column>
      <Column
        dataField="parent_id"
        caption="Kepala"
        lookup={{
          dataSource: positions,
          displayExpr: "name",
          valueExpr: "id",
        }}
        editCellRender={(cell) => (
          <TreeLookupEdit
            defaultValue={cell.value}
            dataSource={positions.map((it) => {
              return { ...it, expanded: true };
            })}
            onValueChanged={(value) => cell.setValue(value)}
          />
        )}
      >
      </Column>
    </DataGridView>
  );
};
export default PositionPage;
